module.exports = __webpack_public_path__ + "img/live.9eec79b6.svg";